import { Helper } from '../Helper';
const doNothing = () => {
};
export class CreateIteratorIterableIteratorHelper extends Helper {
    constructor(options) {
        super();
        this.mapKey = options.mapKey === undefined ? doNothing : options.mapKey;
        this.mapValue = options.mapValue === undefined ? doNothing : options.mapValue;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.createIterableIteratorBase({
            handleNext: (innerOptions) => {
                sb.emitOp(node, 'DUP');
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                this.mapValue(innerOptions);
                sb.emitOp(node, 'SWAP');
                sb.emitSysCall(node, 'Neo.Iterator.Key');
                this.mapKey(innerOptions);
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PACK');
                sb.emitHelper(node, innerOptions, sb.helpers.wrapArray);
            },
        }));
    }
}

//# sourceMappingURL=CreateIteratorIterableIteratorHelper.js.map
